(() => {
  if (customElements.get('tree-details-pilot')) return;
  customElements.define('tree-details-pilot', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[data-product-section]');
      try { this.specs = JSON.parse(this.querySelector('[data-pilot-specs]').textContent); }
      catch { return; }
      this.onVariantChange = event => this.update(event.detail.variant.id);
      this.section?.addEventListener('variant:change', this.onVariantChange);
      this.update(this.section?.querySelector('[data-variant-input]')?.value);
    }
    disconnectedCallback() {
      this.section?.removeEventListener('variant:change', this.onVariantChange);
    }
    update(id) {
      const spec = this.specs.find(item => String(item.id) === String(id));
      if (!spec) return;
      const lit = /com led|fibra/i.test(spec.lighting || '') && !/sem led/i.test(spec.lighting || '');
      const numeric = value => Number(value) > 0 ? new Intl.NumberFormat('pt-BR').format(Number(value)) : '';
      const fields = {
        height: spec.height || '', diameter: spec.diameter || '', tips: numeric(spec.tips),
        lights: lit ? numeric(spec.lights) : '', lighting: spec.lighting || '',
        assembly: spec.assembly || '', weight: spec.weight || '', boxes: numeric(spec.boxes)
      };
      Object.entries(fields).forEach(([key, value]) => {
        this.querySelectorAll(`[data-pilot-field="${key}"]`).forEach(node => { node.textContent = value; });
        this.querySelectorAll(`[data-pilot-row="${key}"]`).forEach(node => { node.hidden = !value; });
      });
      this.querySelector('[data-pilot-selection]').textContent = spec.title;
      this.querySelectorAll('[data-pilot-lit]').forEach(node => { node.hidden = !lit; });
      this.querySelectorAll('[data-pilot-unlit]').forEach(node => { node.hidden = lit; });
    }
  });
})();
